/*
 * @Date: 2023-11-01 14:33:45
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2024-06-03 15:55:10
 * @FilePath: /nicee-web-tw/src/components/VoiceRoom/currentUserProvider.js
 * @Description: 语音房当前用户
 */
// const currentUserProvider = Vue.observable({
//   user: {},
//   seatInfo: {}
// });
import VoiceRoomIM from '@/components/VoiceRoom/voiceRoomIM';

class User {
  seatInfo = {
    avatarURL: '', //
    bubble_BOX: '', //
    mic: 0, //1开0关
    nickname: '', //
    pfpFrame: '', //
    roomUid: '', //
    seatIndex: 0, //
    sex: '', //
    userUuid: '', //
    userLevel: '', //
    spendAmount: 0,
    rankingScore: 0,
    uniqueMic: null,
    time: null
  };
  userInfo = {};
  uuid = '';
  gender = undefined;
  // isOnSeat = false; //是否在麦位上
  isCreate = false; //是否房主
  isAdmin = false; //是否管理员
  get isOnSeat() {
    return this.seatInfo && this.seatInfo.userUuid ? true : false;
  }
  // im上的装扮
  get dressup() {
    return this.voiceRoomIMProvider.getMemberDressUp(this.uuid);
  }
  // im上的头像框
  get pfpFrame() {
    return this.voiceRoomIMProvider.getMemberPfpFrame(this.uuid);
  }
  /**
   * @description: 更新当前用户麦位资料
   * @param {*} seatInfo
   * @return {*}
   */
  constructor(voiceRoomIMProvider) {
    this.voiceRoomIMProvider = voiceRoomIMProvider;
  }

  updateSeat(seatInfo) {
    this.seatInfo = seatInfo || {};
  }

  //查询当前用户是否在麦位上
  isCurrentUser(uuid) {
    return this.uuid == uuid;
  }

  async setUserInfo(userInfo) {
    this.userInfo = userInfo;
    this.uuid = userInfo.uuid;
  }

  setCreate(isCreate) {
    this.isCreate = isCreate;
  }
  setAdmin(isAdmin) {
    this.isAdmin = isAdmin;
  }
}
const currentUserProvider = new User(VoiceRoomIM);

export default currentUserProvider;
